import { useParams } from "react-router-dom";

import { useEffect } from "react";
import { useState } from "react";

import {
  getAcolitoById,
  updateAcolito,
  updateDisponibilidadAcolito,
} from "../../helpers/acolitos";
import { Loading } from "../../common/components/Loading";
import { InfoPersonal } from "../components/DetallesAcolito/InfoPersonal";
import { ConocimientoPuestos } from "../components/DetallesAcolito/ConocimientoPuestos";
import { Disponibilidad } from "../components/DetallesAcolito/Disponibilidad";
import {
  Save,
  SentimentVeryDissatisfied,
  ThumbUpAlt,
} from "@mui/icons-material";
import { CustomModal } from "../../common/components/CustomModal";
import { Alert, Box, Button, Fade, Snackbar, Typography } from "@mui/material";
import { updatePuesto } from "../../helpers/puestos";

export const DetallesAcolito = () => {
  //nombre de la pestaña
  document.title = "Editar información";

  const { id: idAcolito } = useParams();

  const [acolito, setAcolito] = useState({});
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [puestosAcolito, setPuestosAcolito] = useState([]);
  const [horarios, setHorarios] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(
    "Error: faltan campos por llenar."
  );
  const [loadingText, setLoadingText] = useState("Obteniendo información");
  const [showCambiosGuardados, setShowCambiosGuardados] = useState(false);

  const getData = async () => {
    const ac = await getAcolitoById(idAcolito);
    setAcolito(ac);
    setLoading(false);
  };

  const validarCampos = () => {
    if (
      acolito.nombre === "" ||
      acolito.nombre === undefined ||
      acolito.nombre.trim() === ""
    ) {
      setErrorAlert("Error: el nombre no puede estar vacío.");
      return false;
    }
    if (
      acolito.apellido_p === "" ||
      acolito.apellido_p === undefined ||
      acolito.apellido_p.trim() === ""
    ) {
      setErrorAlert("Error: el apellido paterno no puede estar vacío.");
      return false;
    }
    if (
      acolito.apellido_m === "" ||
      acolito.apellido_m === undefined ||
      acolito.apellido_m.trim() === ""
    ) {
      setErrorAlert("Error: el apellido materno no puede estar vacío.");
      return false;
    }
    if (acolito.fecha_nacimiento === "Invalid Date") {
      setErrorAlert("Error: fecha de nacimiento inválida.");
      return false;
    }
    if (
      acolito.celular === "" ||
      acolito.celular === undefined ||
      acolito.celular.trim() === ""
    ) {
      setErrorAlert("Error: el celular no puede estar vacío.");
      return false;
    }
    if (
      acolito.correo === "" ||
      acolito.correo === undefined ||
      acolito.correo.trim() === ""
    ) {
      setErrorAlert("Error: el correo no puede estar vacío.");
      return false;
    }
    if (
      acolito.id_cargo === "" ||
      acolito.id_cargo === undefined ||
      acolito.id_cargo === null
    ) {
      setErrorAlert("Error: el rango no puede estar vacío.");
      return false;
    }
    if (horarios.length !== 0) {
      //Checar que todos los horarios tengan un día de la semana y una hora
      for (let i = 0; i < horarios.length; i++) {
        if (horarios[i].dia_semana === null) {
          setErrorAlert("Error: falta seleccionar un día de la semana.");
          return false;
        }
        if (horarios[i].hora === "" || horarios[i].hora.trim() === "") {
          setErrorAlert("Error: falta seleccionar una hora.");
          return false;
        }
      }
    }

    return true;
  };

  const guardarCambios = async () => {
    setShowModal(false);
    let error = true;
    if (validarCampos()) {
      error = false;
      //Guardar cambios
      setGuardando(true);
      setLoading(true);
      setLoadingText("Guardando información del acólito");
      const responseAC = await updateAcolito(acolito);
      if (responseAC.status !== 200) {
        console.log("Error al actualizar acolito");
        setErrorAlert("Error al guardar los datos del acólito.");
        error = true;
      }
      if (!error) {
        //Guardar puestos
        setLoadingText("Guardando puestos del acólito");
        const responsePuestos = await updatePuesto(puestosAcolito, idAcolito);
        if (responsePuestos.status !== 200) {
          console.log("Error al actualizar puestos");
          setErrorAlert("Error al guardar los puestos del acólito.");
          error = true;
        }
      }

      if (!error) {
        //Guardar horarios
        setLoadingText("Guardando disponibilidad del acólito");
        const responseHorarios = await updateDisponibilidadAcolito(
          horarios,
          idAcolito
        );
        if (responseHorarios.status !== 200) {
          console.log("Error al actualizar horarios");
          setErrorAlert("Error al guardar la disponibilidad del acólito.");
          error = true;
        }
        setGuardando(false);
        setShowCambiosGuardados(true);
        setLoading(false);
      }
    }

    if (error) {
      setShowAlert(true);
      setGuardando(false);
      setShowModal(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (acolito.message) {
    return (
      <div>
        <Fade in={true} timeout={1000}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "60vh",
            }}
          >
            <SentimentVeryDissatisfied
              style={{ fontSize: 100, marginBottom: 30 }}
              color="secondary"
            />
            <Typography
              id="transition-modal-title"
              variant="h4"
              color="secondary"
              fontWeight={500}
            >
              NO SE ENCONTRÓ EL ACÓLITO
            </Typography>
          </Box>
        </Fade>
      </div>
    );
  }

  return (
    <>
      {loading && <Loading texto={loadingText} />}
      <InfoPersonal acolito={acolito} setAcolito={setAcolito} />
      <Disponibilidad
        idAcolito={idAcolito}
        horarios={horarios}
        setHorarios={setHorarios}
      />
      <ConocimientoPuestos
        idAcolito={idAcolito}
        puestosAcolito={puestosAcolito}
        setPuestosAcolito={setPuestosAcolito}
      />
      {/* Alerta de error */}
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert
          onClose={() => setShowAlert(false)}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {errorAlert}
        </Alert>
      </Snackbar>
      {/* Modal para confirmar que deseamos guardar los cambios */}
      {
        <CustomModal
          open={showModal}
          funBtn1={guardarCambios}
          funBtn2={() => setShowModal(false)}
          btnDisabled={guardando}
        />
      }
      {/* Modal para confirmar que se guardaron los cambios */}
      <CustomModal
        open={showCambiosGuardados}
        title="Cambios guardados"
        text="Los cambios se guardaron correctamente."
        txtBtn1="Aceptar"
        funBtn1={() => setShowCambiosGuardados(false)}
        iconBtn1={<ThumbUpAlt />}
        segundoBtn={false}
      />
      <div style={{ position: "fixed", bottom: 20, right: 20 }}>
        <Button
          startIcon={<Save style={{ fontSize: 20 }} />}
          sx={{
            borderRadius: 2,
            boxShadow: 8,
            transition: "transform 0.3s",
            bgcolor: "white",
            "&:hover": {
              transform: "scale(1.1)",
            },
            fontSize: 20,
            fontWeight: 900,
            padding: "10px 20px",
          }}
          onClick={() => setShowModal(true)}
        >
          Guardar
        </Button>
      </div>
    </>
  );
};
